import { API_REQUEST, FAILURE } from 'omega-rtc/middlewares/api-middleware';
import { snackBar } from 'omega-rtc/components/custom/SnackBar';
import type { FSA } from 'types/redux';

export const SEARCH_COMMS_TRACE = 'SEARCH_COMMS_TRACE';

export const COMMS_TRACE_RETRY_MESSAGE = 'Comms trace query failed, please retry';

export const COMMS_TRACE_PAGE_SIZE = 25;

export interface SearchCommsTraceParams {
  userIDs: string[];
  startTime: string;
  endTime: string;
  timezone: string;
  page: number;
  pageSize: number;
}

interface CommsTraceErrorBody {
  target?: string;
  reason?: string;
  message?: string;
}

// meta.requestId is copied into the REQUEST/SUCCESS/FAILURE actions, so the reducer can drop stale responses.
let lastRequestId = 0;

export const commsTraceErrorHandler = (
  error: any,
  next: (action: any) => any,
  action: any,
  defaultErrorHandler: (error: any, next: any, action: any) => void,
) => {
  const body: CommsTraceErrorBody | undefined = error?.response?.data;
  const reason = body?.reason;

  if (reason !== 'invalid_argument' && reason !== 'pre_condition_failed' && reason !== 'internal') {
    return defaultErrorHandler(error, next, action);
  }

  let notConfigured = false;
  if (reason === 'invalid_argument') {
    (body?.message || '')
      .split(';')
      .map(part => part.trim())
      .filter(Boolean)
      .forEach(content => snackBar.error({ content }));
  } else if (reason === 'pre_condition_failed') {
    notConfigured = true;
  } else {
    snackBar.error({ content: COMMS_TRACE_RETRY_MESSAGE });
  }

  return next({
    ...action,
    type: action.type + FAILURE,
    payload: error,
    meta: {
      ...action.meta,
      request: action.payload,
      requestStatus: FAILURE,
      notConfigured,
    },
  });
};

export function searchCommsTrace(params: SearchCommsTraceParams): FSA {
  lastRequestId += 1;
  const { userIDs, startTime, endTime, timezone, page, pageSize } = params;
  return {
    type: SEARCH_COMMS_TRACE,
    payload: {
      method: 'GET',
      url: '/ucd/comms-trace',
      params: { userIDs, startTime, endTime, timezone, page, pageSize },
    },
    meta: {
      [API_REQUEST]: true,
      requestId: lastRequestId,
      errorHandler: commsTraceErrorHandler,
    },
  };
}
